import { http } from "./api";

export const getUser = () => {
  return http.get('/users/me',
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};

export const getProfileDataAPI = (id) => {
  return http.get(`/users/me/profile`,
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  ).then((res) => res.data);
};

export const setProfileDataAPI = (id, config) => {
  return http.put(`/users/me/profile`,
    {
      "theme": config.theme,
      "past_days": config.past_days,
      "theme_color": config.theme_color,
      "first_month": config.first_month,
      "first_year": config.first_year,
      "is_custom_initial_date": config.is_custom_initial_date,
      "current_view": config.current_view,
      "design": config.design,
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
};

export const setLayoutAPI = (id, layout) => {
  return http.patch(`/users/me/profile`,
    {
      "current_view": +layout
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const setThemeAPI = (id, theme) => {
  return http.patch(`/users/me/profile`,
    {
      "theme": theme
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const setPastDaysAPI = (id, pastDays) => {
  return http.patch(`/users/me/profile`,
    {
      "past_days": pastDays
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const setThemeColorAPI = (id, themeColor) => {
  return http.patch(`/users/me/profile`,
    {
      "theme_color": themeColor
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const setFirstMonthAPI = (id, firstMonth) => {
  return http.patch(`/users/me/profile`,
    {
      "first_month": firstMonth
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const setFirstYearAPI = (firstYear) => {
  return http.patch(`/users/me/profile`,
    {
      "first_year": firstYear
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

// The view bar's arrow step and home buttons.
export const setNavAPI = (nav) => {
  return http.patch(`/users/me/profile`,
    { "nav": nav },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

// The month the calendar opens on, kept as the custom first month and year; null opens it on today.
export const setAnchorAPI = (month) => {
  return http.patch(`/users/me/profile`,
    month
      ? { "is_custom_initial_date": true, "first_month": month.month() + 1, "first_year": month.year() }
      : { "is_custom_initial_date": false },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}

export const setDesignAPI = (designName) => {
  return http.patch(`/users/me/profile`,
    {
      "design": designName
    },
    {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('token')}`
      }
    }
  )
}